export default "__VITE_ASSET__CbChAmu___"